import {FormHelperText} from "@material-ui/core"
import React from "react"

interface IErrorProps {
  errorMsg?: string
}

const Error: React.FunctionComponent<IErrorProps> = ({errorMsg}) => {
  return errorMsg ? <FormHelperText error>{errorMsg}</FormHelperText> : <div />
}

export default Error
